import { IStandard } from "@/search/Langston/types/IStandard";

export const checkForEqualContentIds = (
  results: IStandard[],
  compare: IStandard[] | string[],
) => {
  if (results.length !== compare.length) {
    return false;
  }
  let compareContentIds = compare;
  if (compare.length > 0 && typeof compare[0] !== "string") {
    compareContentIds = (compare as IStandard[]).map((std) => std.id).sort();
  }

  const resultContentIds = results.map((std) => std.id).sort();
  return (compareContentIds as string[]).every(
    (val, index) => val === resultContentIds[index],
  );
};
